<div class="wrapper">
    <div class="content-wrapper">
        <div class="mobile-screen">
            <div class="br-section-wrapper-take-order">
                <div class="beta-version"><b>Beta version!!</b>
                    <div class="beta-description">For Testing purpose only</div>
                </div>
                <div class="row">
                    <div class="col-12 text-center user-container">
                    </div>

                    <div class="input-container col-12" style="padding-left: 15px; margin-top: 20px;">
                        <h6><b>Inventory</b></h6>
                        <ng-select [(ngModel)]="selectedDealer" [virtualScroll]="true" class="custom"
                            (ngModelChange)="allowOrderSelection = false; showInventoryDetails(selectedDealer)"
                            placeholder="Start typing to search dealer..." (click)="checkTenantFiltersAvailability()">
                            <ng-option *ngFor="let dealer of dealers; let dealerIndex = index" [value]="dealer">
                                {{dealer?.dealer}} | {{dealer?.address}}</ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>

            <div
                [ngClass]="{'br-section-wrapper-take-order-active': allowOrderSelection && selectedDealer, 'br-section-wrapper-take-order-inactive': (!allowOrderSelection || !selectedDealer)}">
                <div class="row">
                    <div class="col-6">Location Id : {{selectedDealer?.locationID}}</div>
                    <div class="col-6">Dealer : {{selectedDealer?.dealer}}</div>

                    <div class="col-6">TAC : {{selectedDealer?.tac}}</div>
                    <div class="col-6">CO Billtype : {{selectedDealer?.billtype?.billingCodeName}}</div>

                    <div class="col-6">City : {{selectedDealer?.city}}</div>
                    <div class="col-6">State : {{selectedDealer?.state}}</div>
                    <div class="col-6">Zip : {{selectedDealer?.zip}}</div>
                    <div class="col-12">Address : {{selectedDealer?.address}}</div>
                </div>
                <hr>


                <div class="row product-element" [ngClass]="tank?.class" *ngFor="let tank of tblTanks">
                    <div class="col-6">
                        Tank ID : {{tank?.counter}}
                    </div>
                    <div class="col-6">
                        Product : {{tank?.productName}}
                    </div>
                    <div class="col-6">
                        Date : {{tank?.lastDeliveryDate}}
                    </div>
                    <div class="col-6">
                        Ullage : {{tank?.ullage}}
                    </div>
                    <div class="col-6">
                        Last Delivery : {{tank?.lastInventory}}
                    </div>
                    <div class="col-12">
                        Gallons : <input type="number" class="take-order-input" placeholder="Gallons">
                    </div>
                </div>



                <div class="row product-padding">
                    <div class="row text-center">
                        <div class="col-12 text-center" *ngIf="(!tblTanks) && allowOrderSelection">
                            <img src="assets/images/ajax-loader.gif" /> Fetching products
                        </div>
                    </div>
                    <div class="row  product-element " [ngClass]="product?.class" *ngFor="let product of []">
                        <div class="col-6 text-center">
                            <div class="text-center product-name-label" *ngIf="product?.productName">
                                {{product?.productName}}</div>
                            <ng-select [(ngModel)]="newProductAdded" [virtualScroll]="true" class="custom text-left"
                                *ngIf="!product?.productName" (ngModelChange)="addProduct(product, newProductAdded)"
                                placeholder="Product" (click)="checkTenantFiltersAvailability()"
                                style="margin-top: -8px">
                                <ng-option *ngFor="let newProduct of productList; let productIndex = index"
                                    [value]="newProduct">
                                    {{newProduct?.productName}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-6 "><input type="number" class="take-order-input" placeholder="Quantity"
                                [(ngModel)]="product.quantity"></div>
                        <!-- <div class="col-2 ">{{product?.tankName? product?.tankName : "Not Available"}}</div> -->
                        <div class="col-12 ">
                            <ng-select [(ngModel)]="product.terminalSupplierMapping" [virtualScroll]="true"
                                class="custom" (ngModelChange)="displayCount(product.terminalSupplierMapping);"
                                placeholder="Terminal : TBD" (click)="checkTenantFiltersAvailability()">
                                <ng-option value="undefined" [disabled]="true">Terminal</ng-option>
                                <ng-option *ngFor="let terminalSupplierMapping of terminalSuppliersMapping | keyvalue"
                                    [value]="terminalSupplierMapping.value">
                                    {{terminalSupplierMapping?.key}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-12 ">
                            <ng-select [(ngModel)]="product.tblLoadUnder" [virtualScroll]="true" class="custom"
                                [disabled]="!product?.terminalSupplierMapping"
                                (ngModelChange)="displayCount(product.tblLoadUnder);" placeholder="Supplier : TBD"
                                (click)="checkTenantFiltersAvailability()">
                                <ng-option value="undefined" [disabled]="true">Supplier</ng-option>
                                <ng-option *ngFor="let tblLoadUnder of product?.terminalSupplierMapping?.tblLoadUnders"
                                    [value]="tblLoadUnder">
                                    {{tblLoadUnder?.loadUnderName}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="col-12 text-right">
                            <button class="remove-product-button" (click)="removeProduct(product)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                        <div class="col-12">
                            <hr class="new4" />
                        </div>
                    </div>

                    <div class="row" style="margin-bottom: 20px;width: 113%;">
                        <div class="col-12">
                            <button class="add-product-button">Save
                            </button>
                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>
</div>